// Site-scoped device reads (B.2). Devices are created only via layout
// import; these are list + detail.

import { request, type ApiResponse } from "../client";
import type { DeviceMetadataPatch, DeviceOut } from "../types/device";

function base(a: string, t: string, s: string): string {
  return `/api/v1/accounts/${encodeURIComponent(a)}/tenants/${encodeURIComponent(
    t,
  )}/sites/${encodeURIComponent(s)}/devices`;
}

export const devices = {
  list: (
    accountSlug: string,
    tenantSlug: string,
    siteSlug: string,
  ): Promise<ApiResponse<DeviceOut[]>> =>
    request<DeviceOut[]>("GET", base(accountSlug, tenantSlug, siteSlug)),

  get: (
    accountSlug: string,
    tenantSlug: string,
    siteSlug: string,
    deviceSlug: string,
  ): Promise<ApiResponse<DeviceOut>> =>
    request<DeviceOut>(
      "GET",
      `${base(accountSlug, tenantSlug, siteSlug)}/${encodeURIComponent(deviceSlug)}`,
    ),

  patch: (
    accountSlug: string,
    tenantSlug: string,
    siteSlug: string,
    deviceSlug: string,
    body: DeviceMetadataPatch,
  ): Promise<ApiResponse<DeviceOut>> =>
    request<DeviceOut>(
      "PATCH",
      `${base(accountSlug, tenantSlug, siteSlug)}/${encodeURIComponent(deviceSlug)}`,
      body,
    ),
};
